import { isNavigatingInTradeBlotter } from 'epic/utils/navigation/navigation';
import { filter, map } from 'rxjs/operators';
import type { SpEpic } from 'shared/middlewares/epic/epicMiddleware.factory';
import { blotterPanelItemReset } from 'state/blotters/blotterPanel/blotterPanel.action';

export function resetBlotterPanelEpics(): SpEpic {
  return action$ => action$.pipe(filter(isNavigatingInTradeBlotter), map(blotterPanelItemReset));
}
